import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import heroImage from "@/assets/hero-image.webp";

export const LandingFeature = () => {
  return (
    <section className="relative w-full md:min-h-[548px] flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 py-8 md:py-12 px-6 md:px-12 lg:px-16 overflow-hidden">
      {/* Aqueous Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#D8DEE9]/20 via-white to-[#FFD166]/10 -z-10"></div>

      {/* Floating Blob Effect */}
      <div
        className="absolute -left-32 top-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-10 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(74, 78, 105, 0.4) 0%, rgba(74, 78, 105, 0) 70%)",
          animation: "pulse 8s ease-in-out infinite",
        }}
      ></div>

      {/* LCP-critical content - no animations to prevent render delay */}
      <div className="flex-1 max-w-[556px] relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-[#4A4E69] mb-4 leading-tight">
          A clareza que sua mente merece.
        </h2>

        <p className="text-base md:text-lg text-[#272D37]/80 leading-relaxed mb-4 md:mb-4">
          KopfAI é sua assistente pessoal de IA direcionada ao seu bem-estar mental. Utilize princípios da Terapia
          Cognitivo-Comportamental (TCC) para entender seus pensamentos e encontrar o equilíbrio.
        </p>

        <Link to="/auth?tab=signup">
          <Button
            className="w-full md:w-[281px] h-[60px] rounded-full bg-[#FFD166] hover:bg-[#FFD166]/90 text-[#4A4E69] text-lg font-bold mb-1 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 group"
            style={{
              boxShadow: "0 15px 35px rgba(255, 209, 102, 0.25)",
            }}
          >
            <span className="transition-all duration-300 group-hover:scale-105">Comece seu teste grátis</span>
          </Button>
        </Link>

        <p className="text-sm text-[#272D37]/60 ml-3 flex items-center gap-1">
          <span className="inline-block w-1 h-1 rounded-full bg-[#FFD166]"></span>
          Sem cartão • Sem compromisso
        </p>
      </div>

      <div
        className="hidden md:flex flex-shrink-0 justify-center relative"
        style={{
          animation: "fadeInRight 0.8s ease-out 0.4s backwards",
        }}
      >
        {/* Glow effect behind image */}
        <div
          className="absolute inset-0 blur-2xl opacity-30 -z-10"
          style={{
            background: "radial-gradient(circle, rgba(255, 209, 102, 0.6) 0%, transparent 70%)",
            animation: "pulse 4s ease-in-out infinite",
          }}
        ></div>

        <div className="relative group">
          <img
            src={heroImage}
            alt="Ilustração representando bem-estar mental e clareza de pensamento com a KopfAI"
            width="256"
            height="356"
            className="w-48 sm:w-56 md:w-64 h-auto"
          />

          {/* Subtle border glow */}
          <div
            className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
            style={{
              background: "linear-gradient(135deg, rgba(255, 209, 102, 0.2), rgba(74, 78, 105, 0.1))",
              filter: "blur(20px)",
            }}
          ></div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
            opacity: 0.3;
          }
          50% { 
            transform: scale(1.1);
            opacity: 0.15;
          }
        }
      `}</style>
    </section>
  );
};
